import trackingService from '../state/services/tracking';
import { SEGMENT_EVENTS } from './tracking';

/**
 *
 * @param {events, carouselTitle} trackingData
 */
function trackCarouselEvents(trackingData) {
  const { events, carouselTitle } = trackingData;

  const payload = {
    events: events.map((event, index) => {
      return {
        position: index + 1,
        event_id: event.id,
        event_name: event.title,
      };
    }),
    carousel_title: carouselTitle,
  };
  trackingService.trackEvent(SEGMENT_EVENTS.CAROUSEL_VIEWED, payload);
}

export default trackCarouselEvents;
